import { useCallback, useEffect, useState } from 'react';
import { TAllOfferChatOnboardings } from 'shared/types/chatOnboarding';

import { useOfferContext } from '../../../../../context';
import { getChatOnboardingCookie, setChatOnboardingCookie } from '../../../../../utils/chatOnboarding';

interface IOnboardingTooltipResult {
  open: boolean;
  onboardingText: string;
  closeHandler: () => void;
}

const ONBOARDING_COOKIE_NAME_MAP: Record<keyof TAllOfferChatOnboardings, string> = {
  offerChatOnboarding: 'frontend-serp.offer_chat_onboarding_shown',
};

export const useChatOnboarding = (onboardingType: keyof TAllOfferChatOnboardings): IOnboardingTooltipResult => {
  const { offer, allOfferChatOnboardings } = useOfferContext();
  const [open, setOpen] = useState(false);

  const cookieName = ONBOARDING_COOKIE_NAME_MAP[onboardingType];

  const closeHandler = useCallback(() => {
    setOpen(false);
  }, []);

  const canShowForOffer = allOfferChatOnboardings[onboardingType]?.onboardingOfferId === offer.id;
  const chatWasOpened = allOfferChatOnboardings[onboardingType]?.wasChatOpened;
  const onboardingText = allOfferChatOnboardings[onboardingType]?.onboardingText ?? '';

  useEffect(() => {
    if (canShowForOffer && !getChatOnboardingCookie(cookieName)) {
      setOpen(true);
      setChatOnboardingCookie(cookieName);
    }
  }, [canShowForOffer, cookieName]);

  useEffect(() => {
    if (open && chatWasOpened) {
      closeHandler();
    }
  }, [open, chatWasOpened, closeHandler]);

  return {
    open,
    onboardingText,
    closeHandler,
  };
};
